import React from 'react';

export default class Button extends React.Component {
  render() {
    let {
      className = '',
      primary,
      seconday,
      store,
      modifier,
      ariaLabel = '',
      ...rest
    } = this.props;
    className = `rilrtl-button ${className}`;
    if (store) {
      if (primary || seconday) {
        className += ' rilrtl-button--luxesecondary';
      }
    } else {
      if (primary || seconday) {
        className += ' rilrtl-button--secondary';
      }
    }

    if (modifier && typeof modifier === 'string') {
      className += ` rilrtl-button--${modifier}`;
    } else if (modifier && Array.isArray(modifier)) {
      className = modifier.reduce((acc, item) => {
        acc += ` rilrtl-button--${item}`;
        return acc;
      }, className);
    }

    const ariaLabelText =
      (typeof this.props.children == 'string' && this.props.children) || ariaLabel || '';

    const handleKeyDown = (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        e.currentTarget.click();
      }
    };

    return (
      <button className={className} {...rest} aria-label={ariaLabelText} role='button' onKeyDown={handleKeyDown}>
        {this.props.children}
      </button>
    );
  }
}
